import { FormArray, FormGroup } from '@angular/forms';

export const calculateAge = (
  dateOfBirth: string,
  coverageEffectiveDateValue: string,
): number => {
  const coverageEffectiveDate: Date = new Date(coverageEffectiveDateValue);
  const birthDate: Date = new Date(dateOfBirth);
  let age: number =
    coverageEffectiveDate.getFullYear() - birthDate.getFullYear();
  const month: number = coverageEffectiveDate.getMonth() - birthDate.getMonth();

  // due to how we format date values we need to compare UTC date to normal date. birthDate comes from
  // FormControls
  if (
    month < 0 ||
    (month === 0 && coverageEffectiveDate.getDate() < birthDate.getUTCDate())
  ) {
    age -= 1;
  }

  return age;
};

export const filterMembersByMinimumAge = (
  membersList: string[],
  memberForm: FormArray | FormGroup,
  coverageEffectiveDateValue: string,
  minAge: number,
): boolean =>
  membersList?.every((member) => {
    const memberControls =
      member === 'stepParents'
        ? memberForm['controls'][member]?.controls
        : [memberForm.controls[member]];

    return memberControls?.every((memberControl) => {
      const memberDoB = memberControl?.get('date_of_birth')?.value;
      const memberAge = calculateAge(memberDoB, coverageEffectiveDateValue);

      return memberAge >= minAge;
    });
  });
